module.exports = __webpack_public_path__ + "static/media/Декларация за корпоративно управление_2020.b5fc2f55.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Декларация за корпоративно управление_2020.pdf
// module id = 109
// module chunks = 0